export default "__VITE_ASSET__CpsODjhD__"